<template>
  <CContainer>
    <h3>Productos Contrato de Arrendamiento</h3>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <h3>{{ companyName }}</h3>
        <CRow>
          <CCol col="3">
            <CCallout color="info" class="m-0">
              <span class="text-muted">Equipos Arrendados</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-boxes text-info h2 mr-3"></i>
                <strong class="h4 align-middle">{{ numberRecords }}</strong>
              </div>
            </CCallout>
          </CCol>
          <CCol col="3">
            <CCallout color="info" class="m-0">
              <span class="text-muted">Valor Arrendamiento</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-cash-stack text-info h2 mr-3"></i>
                <strong class="h4 align-middle">${{ valueRentedProducts }}</strong>
              </div>
            </CCallout>
          </CCol>
          <CCol col="3">
            <CCallout color="warning" class="m-0">
              <span class="text-muted">Costo Arrendamiento</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-cash-coin text-warning h2 mr-3"></i>
                <strong class="h4 align-middle">${{ costRentedProducts }}</strong>
              </div>
            </CCallout>
          </CCol>
          <CCol col="3">
            <CCallout color="success" class="m-0">
              <span class="text-muted">Utilidad Arrendamiento</span>
              <div class="d-flex align-items-center">
                <i class="bi bi-coin text-success h2 mr-3"></i>
                <strong class="h4 align-middle">${{ utilityRentedProducts }}</strong>
              </div>
            </CCallout>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="6" class="d-flex justify-content-end align-items-center">
            <CButton 
              color="secondary" 
              variant="outline"
              class="mt-2" 
              :to="returnPath">
              <i class="bi bi-arrow-left-circle h4 align-middle mr-2"></i>
              <span>Regresar</span>
            </CButton>
            <CButton 
              color="success" 
              class="mt-2 ml-2"
              :to="`${rootPath}/agregar`">
              <i class="bi bi-plus-circle h4 align-middle mr-2"></i>
              <span>Agregar</span>
            </CButton>
            <CButton 
              color="info" 
              variant="outline"
              class="mt-2 ml-2"
              @click="(e) => {
                e.preventDefault();
                e.stopPropagation();

                $refs.selectedFile.click();
              }">
              <i class="bi bi-cloud-arrow-up h4 align-middle mr-2"></i>
              <span>Importar</span>
              <CSpinner size="sm" class="align-middle mx-2" v-show="processing" />
            </CButton>
            <CButton 
              color="dark" 
              variant="outline"
              class="mt-2 ml-2"
              disabled
              :to="`${rootPath}/agregar`">
              <i class="bi bi-cloud-arrow-down h4 align-middle mr-2"></i>
              <span>Descargar</span>
            </CButton>
            <input type="file" 
              ref="selectedFile" 
              style="display: none;" 
              @change="(e) => {
                fileRentedProducts = e.target.files;

                importExcelRentedProducts();
              }" 
            />
          </CCol>
        </CRow>

        <CDataTable 
          hover 
          class="table-hover-icons"
          responsive
          :items="rentedProducts" 
          :fields="fields" 
          :items-per-page="5">
          <template #producto="{ item }">
            <td>
              <div>
                <CIcon v-if="item.estado == 'A'" name="cil-check-circle" class=" mr-1 text-success" />
                <CIcon v-if="item.estado == 'I'" name="cil-x-circle" class=" mr-1 text-danger" />
                <span>{{ item.producto }}</span>
              </div>
              <div>
                <h5>{{ item.codigo }}</h5>
              </div>
              <div v-if="item.numero_Serial">
                <i class="bi bi-upc-scan mr-1"></i>
                <span>{{ item.numero_Serial }}</span>
              </div>
            </td>
          </template>
          <template #detalles="{ item }">
            <td>
              <div>
                <CIcon name="cil-calendar" class="text-success mr-1" />
                <span>{{ item.fecha_Entrega }}</span>
              </div>
              <div>
                <i class="bi bi-cash-coin mr-1"></i>
                <span>{{ formatter.format(item.valor_Arriendo, 0) }}</span>
              </div>
              <div>
                <i class="bi bi-box-seam mr-1"></i>
                <span>{{ item.cantidad }}</span>
              </div>
            </td>
          </template>
          <template #acciones="{ item }">
            <td class="d-flex justify-content-end">
              <div class="hover-actions">
                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Desactivar Producto'"
                  @click="tryDelete($event, item.id_ProductoArrendamiento)">
                  <i class="bi bi-exclamation-diamond text-warning h4 hover-icon"></i>
                </a>
                <a href="#" 
                  class="mr-3" 
                  v-c-tooltip="'Borrar Producto'"
                  @click="tryDelete($event, item.id_ProductoArrendamiento)">
                  <i class="bi bi-trash text-danger h4 hover-icon"></i>
                </a>
              </div>
            </td>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)">
        </CPagination>  
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>
  </CContainer>
</template>
<script>
  import { ref } from "vue";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import CONSTANTS from "@/constants";
  import { 
    formatter,
    dividedValueToShow,
    toBase64 
  } from "@/general";
  import {
    dataGridProductosArrendamientos,
    crudProductoArrendamiento,
    resumenProductoArrendamiento
  } from "@/apis/rents";
  import { importFileRentedProducts } from "@/apis/process";

  const fields = [
    {
      key: 'producto',
      label: "Producto",
      _style: 'text-align:center'
    },
    {
      key: 'detalles',
      label: 'Informacion',
      _style: 'text-align:center'
    },
    {
      key: "acciones",
      label: "",
      _style: "text-align:center;"
    }
  ]

  export default ({
    name: "RentedProducts",
    data() {
      return {
        formatter,
        loading: false,
        processing: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        fields,
        rentedProducts: [],
        selectedRentedProductId: "",
        numberRecords: 0,
        valueRentedProducts: "",
        costRentedProducts: "",
        utilityRentedProducts: "",
        fileRentedProducts: ""
      }
    },
    components: {
      LoadingCover
    },
    methods: {
      async getData(page, search) {
        this.loading = true

        try {
          this.page = page;
          this.searchWord = search;

          const { count, results } = await dataGridProductosArrendamientos(this, page, search, this.contractId)

          this.rentedProducts = results;
          this.pageCount = parseInt(count / this.itemsPerPage);

          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++;
          }
        } catch {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async getDataSummary() {
        const parameters = {
          "Id_ContratoArrendamiento": this.contractId
        }

        try {
          const { Cantidad, Valor_Arriendo, Valor_Costo } = await resumenProductoArrendamiento(this, parameters);

          this.numberRecords = Cantidad;
          this.valueRentedProducts = dividedValueToShow(Valor_Arriendo);
          this.costRentedProducts = dividedValueToShow(Valor_Costo);
          this.utilityRentedProducts = dividedValueToShow(Valor_Arriendo - Valor_Costo);
        } catch (error) {
          error
        }
      },
      tryDelete(e, idRentedProduct) {
        e.preventDefault();
        e.stopPropagation()

        this.idSelectedRentedProduct = idRentedProduct

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteRentedProduct();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        })
      },
      async deleteRentedProduct() {
        this.loading = true

        try {
          await crudProductoArrendamiento(this, "delete", this.idSelectedRentedProduct);

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          });
        } finally {
          this.loading = false;

          this.getData();
        }
      },
      async importExcelRentedProducts() {
        this.processing = true;

        try {
          if (this.fileRentedProducts[0].size < 2097152) {
            const fileBase64 = await toBase64(this.fileRentedProducts).then(file => file);
            const parametros = {
              "Id_ContratoArrendamiento": this.contractId,
              "Archivo_Base64": fileBase64
            }
  
            const { response } = await importFileRentedProducts(this, parametros);
  
            this.$store.commit("setAlert", {
              color: "success",
              message: response,
              show: 5
            });
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: "El archivo cargado es superior a 2MB.",
              show: 5
            });
          }
        } catch (error) {
          console.log(error);

          this.$store.commit("setAlert", {
            color: "danger",
            message: `NO se pudo cargar el archivo para procesar. Error: ${error.status} - ${error.statusText}`,
            show: 5
          });
        } finally {
          this.processing = false;
          this.getDataSummary();
        }
      }
    },
    setup() {
      const rootPath = ref("");
      const returnPath = ref("");
      const contractId = ref("");

      return {
        rootPath,
        returnPath,
        contractId
      }
    },
    mounted() {
      this.contractId = this.$router.currentRoute.params.id;
      this.rootPath = this.$router.currentRoute.fullPath;
      const temp = this.rootPath.split("/").at(-1);

      this.returnPath = this.rootPath.replace(`/${this.contractId}`, "").replace(`/${temp}`, "");

      this.getData();
      this.getDataSummary();
    }
  });
</script>
